import { setConfig } from '@plug-core/appConfig'
import { IStorage } from '@plug-core/interfaces/storage'

const KEY_PREFIX = '__plug_storage__'

export const LocalStorage: IStorage = {
  async clear() {
    localStorage.clear()
  },

  async set(key: string, value: unknown) {
    localStorage.setItem(`${KEY_PREFIX}_${key}`, value as string)
  },

  async get(key: string) {
    return localStorage.getItem(`${KEY_PREFIX}_${key}`)
  },

  async remove(key: string) {
    localStorage.removeItem(`${KEY_PREFIX}_${key}`)
  },

  async listen() {
    return () => true
  },
}

setConfig('localStorage', LocalStorage)
setConfig('sessionStorage', LocalStorage)
